export default {
  select_size: 'Selecciona un tamaño',
  required: 'Obligatorio',
  required_missing: 'Obligatorio — por favor, haz una selección',
  optional: 'Opcional',
  select_up_to: 'Selecciona hasta {{maxCount}}',
};
